export default __webpack_public_path__ + "static/media/mitigation-moisture-meter-check.07619cda.jpg";